import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { difference } from 'lodash'
import { getShortLinks } from 'cityads-v3/actions/shortLink'
import { RootState } from 'cityads-v3/types/reducer'

/**
 * Массовое сокращение ссылок
 * @param links список ссылок для сокращения
 * @param isShortLink? режим сокращенных ссылок
 */
export function useShortLinks(links: string[], isShortLink = false): [boolean] {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const alreadyLoaded: string[] = useSelector((state: RootState) => state.shortLink.isLoadedArr);

  useEffect(() => {
    const linksToFetch = difference(links, alreadyLoaded)
    if (isShortLink && linksToFetch.length && !isLoading) {
      setIsLoading(true);
      const fetchData = async () => {
        await dispatch(getShortLinks(linksToFetch));
        setIsLoading(false);
      }

      fetchData();
    }
  }, [alreadyLoaded, dispatch, isShortLink, links, isLoading])

  return [isLoading]
}
